import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { T } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { ClearableNumberInputWithFrame } from '../../../../input/clearable-number-input';
import { instrumentBunja } from '../../../state/base';
import { tpslModalInputBunja } from '../../state';

const percentPrecision = 2;

export const LimitPriceInput = () => {
  const {
    pricePrecisionAtom,
    limitPriceInputTextAtom,
    limitPriceDiffFromEntryPriceAtom,
    onLimitPriceInputChange,
    onFromEntryButtonClick,
  } = useBunja(limitPriceInputBunja);
  const t = useTranslations();
  const pricePrecision = useAtomValue(pricePrecisionAtom);
  const limitPriceInputValue = useAtomValue(limitPriceInputTextAtom);
  const priceDiffFromEntryPrice = useAtomValue(limitPriceDiffFromEntryPriceAtom);

  return (
    <div>
      <ClearableNumberInputWithFrame
        precision={pricePrecision}
        value={limitPriceInputValue}
        onChange={onLimitPriceInputChange}
        placeholder={t('Trade.r250401.Enter_price')}
        customStyle
        className={css({
          border: 'none',
          textStyle: 'Title/S/Monospace',
          color: 'content.default.level-5',
          caretColor: 'content.accent.info',
        })}
        suffix={
          <div className={hstack({ gap: 4, textStyle: 'Text/M/Monospace/Regular' })}>
            <Formatted.Percent
              withColor
              withPlus
              toFixed
              method='round-half-up'
              precision={percentPrecision}
              value={String(priceDiffFromEntryPrice)}
            />
            <TextButton
              onClick={onFromEntryButtonClick}
              label={<T id='Trade.r250401.From_entry' />}
              color='neutral'
              size='medium'
            />
          </div>
        }
      />
    </div>
  );
};

const limitPriceInputBunja = bunja(() => {
  const { pricePrecisionAtom } = bunja.use(instrumentBunja);
  const {
    limitPriceInputTextAtom,
    limitPriceDiffFromEntryPriceAtom,
    setLimitPriceInputText,
    setLimitPriceInputValueFromEntry,
  } = bunja.use(tpslModalInputBunja);

  function onLimitPriceInputChange(value: string): void {
    setLimitPriceInputText(value, true);
  }

  function onFromEntryButtonClick() {
    setLimitPriceInputValueFromEntry();
  }

  return {
    pricePrecisionAtom,
    limitPriceInputTextAtom,
    limitPriceDiffFromEntryPriceAtom,
    onLimitPriceInputChange,
    onFromEntryButtonClick,
  };
});
limitPriceInputBunja.debugLabel = 'limitPriceInputBunja';
